<div class="video-modal">
  <div class="modal-header">
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <app-xray-grid
      [hideEmptyCategories]="true"
      [isEditable]="isEditable"
      [studyFileIds]="studyFileIds"
    ></app-xray-grid>

    <!--<app-additional-xrays
      [studyFiles]="additionalFiles"
      [mediaCategories]="mediaCategories"
      [viewonly]="true"
    ></app-additional-xrays>-->
  </div>
</div>
